import React from 'react';
import ReactDom from 'react-dom';
import SolutionsTabs from './components/solutions-tabs';

var tabsReactElement = document.getElementById( 'solutionsTabs' );
if ( tabsReactElement ) {
	ReactDom.render( <SolutionsTabs />, tabsReactElement );
}